var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cms-social-block", style: _vm.containerStyle },
    [
      _vm._l(_vm.activeLinks, function (link, idx) {
        return _c(
          "a",
          {
            key: idx,
            staticClass: "cms-social-block__link",
            class: [
              "cms-social-block__link--" + _vm.resolvedStyle,
              "cms-social-block__link--" + _vm.size,
            ],
            style: _vm.linkStyle(link),
            attrs: {
              href: link.url,
              target: "_blank",
              rel: "noopener noreferrer",
              title: link.label,
            },
          },
          [_c("i", { class: "fa fa-" + link.icon })]
        )
      }),
      _vm._v(" "),
      !_vm.activeLinks.length
        ? _c("div", { staticClass: "cms-social-block__empty" }, [
            _c("i", { staticClass: "fa fa-share-alt" }),
            _vm._v(" "),
            _c("span", [_vm._v("Add social links via the sidebar")]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }